import { DivTooltip, TooltipBody } from '@wg/wows-react-uikit'
import classNames from 'classnames'
import get from 'lodash/get'
import shuffle from 'lodash/shuffle'
import React, { PureComponent } from 'react'
import { LANGUAGES } from '../../../constants'
import styles from './Flag.scss'

export interface Flag_Props {
    language: String,
    isTooltipEnabled: boolean,
    isTitleEnabled: boolean,
    onClick: () => void | null
}
export class Flag extends PureComponent<Flag_Props, any> {

    render() {
        const language = this.props.language
        const languageTitle = get(LANGUAGES, language, `[ ${language} ]`)
        const isClickable = this.props.onClick !== null

        const icon = <div
            key={language + '_icon'}
            className={classNames(
                styles.language,
                styles[language],
                `_lang-${language}`,
            )} />
        const title = <span className={styles.languageTitle} key={language + '_title'}>
            {languageTitle}
        </span>

        let content = this.props.isTitleEnabled ? [icon, title] : [icon]

        return (
            this.props.isTooltipEnabled ? (
                <div
                    className={classNames(styles.languageWrapper, { [styles.languageWrapperClickable]: isClickable })}
                    onClick={this.props.onClick} >
                    <DivTooltip tooltipBody={<TooltipBody>{languageTitle}</TooltipBody>}>
                        {content}
                    </DivTooltip>
                </div>
            ) : content
        )
    }
}

Flag.defaultProps = {
    language: 'ru',
    isTooltipEnabled: true,
    isTitleEnabled: false,
    onClick: null,
}

export interface Flags_Props {
    className: String,
    languages: Array<String>,
    maxDisplayCount: number,
    needsShuffling: Boolean,
    floating: String,
    onClick: () => void | null,
}

export class Flags extends PureComponent<Flags_Props, any> {
    render() {
        let content = this.props.languages.map((language) => (
            <Flag onClick={this.props.onClick} key={language} language={language} />
        ))

        if (this.props.needsShuffling)
            content = shuffle(content)

        if (content.length > this.props.maxDisplayCount) {
            const languageCount = this.props.maxDisplayCount - 1

            let ellipsisLanguages = this.props.languages.slice(languageCount, content.length)
            ellipsisLanguages = ellipsisLanguages.map((x, index) => (
                <span key={x} className={styles.tooltipLanguageWrapper}>
                    <Flag language={x} isTooltipEnabled={false} isTitleEnabled={true} />
                    {index % 2 === 1 ? <br /> : null}
                </span>
            ))

            content = content.slice(0, languageCount)

            const flagEllipsis = (
                <div key={-1} className={styles.languageWrapper}>
                    <DivTooltip tooltipBody={<TooltipBody>{ellipsisLanguages}</TooltipBody>}>
                        <div className={styles.languageEllipsis}>...</div>
                    </DivTooltip>
                </div>
            )
            content.push(flagEllipsis)
        }
        return (
            <div className={classNames(styles.languages, { [styles.right]: this.props.floating === 'right' }, this.props.className)}>
                {content}
            </div>
        )
    }
}

Flags.defaultProps = {
    className: '',
    languages: [],
    maxDisplayCount: 5,
    needsShuffling: false,
    floating: 'left',
    onClick: null,
}